<template>
  <div>
    <v-dialog v-model="show" max-width="440" @keydown.esc="show = false">
      <v-card>
        <v-card-text v-html="$t('TOOLTIP.ARTWORK.RETURN_POLICY_DESC')" />
      </v-card>
    </v-dialog>

    <div class="return-policy">
      <span
        class="return-policy-btn"
        @click="show = true"
      >{{ $t('TOOLTIP.ARTWORK.RETURN_POLICY_BTN') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  }
};
</script>


<style lang="scss" scoped>
.return-policy {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background-color: #fff;
  text-align: center;
  padding: 8px;
  cursor: pointer;

  &-btn {
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 1.0rem;
    display: flex;
    font-weight: 500;
  }

  &:hover {
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
  }
}
</style>
